<div style="position: relative; display: flex; flex-direction: column">
  <div class="super-search-heading">
    Super Search
  </div>
  <div class="super-search-spacing">
    <table style="margin-bottom: 10px;">
      <tr>
        <td>Order#:</td>
        <td>
          <simple-control [label]="'Order#'" (keyup.enter)="clickSearch('superSearch')" [form]="searchForm" key="ordernumber" type="number">
          </simple-control>
        </td>
      </tr>
      <tr>
        <td>Contact Last Name:</td>
        <td>
          <simple-control [label]="'contactLastName'" (keyup.enter)="clickSearch('superSearch')" [form]="searchForm" key="contactLastName" type="text">
          </simple-control>
        </td>
      </tr>
      <tr>
        <td>Customer Phone:</td>
        <td>
          <simple-control [label]="'customerPhone'" (keyup.enter)="clickSearch('superSearch')" [form]="searchForm" key="customerPhone" type="phone">
          </simple-control>
        </td>
      </tr>
      <tr>
        <td>Carrier Phone:</td>
        <td>
          <simple-control [label]="'carrierPhone'" (keyup.enter)="clickSearch('superSearch')" [form]="searchForm" key="carrierPhone" type="phone">
          </simple-control>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="entityName != null">
    <button class="search-filter-button" [disabled]="!this.searchForm?.valid" (click)="clickSearch('superSearch')">
      <a [class]="!this.searchForm?.valid || isLoading ? 'search-disabled' : ''">Search</a>
    </button>
  </div>
</div>
<div class="super-search-border"></div>
<div style="position: relative; display: flex; flex-direction: column">
  <div class="super-search-heading">
    Historical Search
  </div>
  <div class="super-search-spacing">
   
    <div class="medium muted7" style="padding-bottom: 5px;">Data Category</div>

    <div [class.disabled-link]="isLoading || !sharedServiceClient.getPermissions('orders')" style="padding-bottom: 5px;">
      <p-radioButton styleClass="simple-control" name="entity" value="order" label="Orders" [(ngModel)]="entityName" (ngModelChange)="changeEntity(true, true, true)"></p-radioButton>
    </div>
    <div [class.disabled-link]="isLoading || !sharedServiceClient.getPermissions('invoices')" style="padding-bottom: 5px;">
      <p-radioButton styleClass="simple-control" name="entity" value="invoice" label="Invoices" [(ngModel)]="entityName" (ngModelChange)="changeEntity(true, true, true)"></p-radioButton>
    </div>
    <div [class.disabled-link]="isLoading || !sharedServiceClient.getPermissions('locations')" style="padding-bottom: 5px;" >
      <p-radioButton styleClass="simple-control" name="entity" value="location" label="Locations" [(ngModel)]="entityName" (ngModelChange)="changeEntity(true, true, true)"></p-radioButton>
    </div>
    <div [class.disabled-link]="isLoading || !sharedServiceClient.getPermissions('users')" style="padding-bottom: 10px;">
      <p-radioButton styleClass="simple-control" name="entity" value="user" label="Users" [(ngModel)]="entityName" (ngModelChange)="changeEntity(true, true, true)"></p-radioButton>
    </div>

    @if (entityName !== 'user' && entityName !== 'location') {
      <div class="d-flex align-items-center date-range-dropdown">
        <div class="medium muted7 date-range-label">Date Range</div>
        <p-dropdown [options]="lookups.duration" placeholder="Select" [(ngModel)]="search.duration"
          (ngModelChange)="search.duration = $event; changeDuration()" (keyup.enter)="clickSearch()"
          styleClass="simple-control" [style]="{'width': '100%' ,'margin':'0 10px'}" [showTransitionOptions]="'0ms'"
          [hideTransitionOptions]="'0ms'">
        </p-dropdown>
      </div>
    }

    <div *ngIf="entityName == 'user'">
      <p-dropdown [ngModelOptions]="{standalone: true}"
                  [options]="roles"
                  [ngModel]="role"
                  (ngModelChange)="role = $event; changeEntity();"
                  styleClass="simple-control"
                  placeholder="Select..."
                  [style]="{'width': '100%' }"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'">

      </p-dropdown>
    </div>

    <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>

    <div *ngIf="entityName == null">
      <div class="muted7 italic" style="text-align: center">Select a data category to reveal category specific search parameters.</div>
    </div>
    <div *ngIf="entityName == null || (entityName != null && entityName != 'user') || (entityName == 'user' && role != null)">
      <div [formGroup]="form">
        <div *ngFor="let i of [0,1,2,3,4]" style="padding-bottom: 16px">
          <div style="padding-bottom: 8px;">
            <p-dropdown [ngModelOptions]="{standalone: true}"
                        [options]="visibleFilterOptions"
                        optionLabel="label"
                        dataKey="key"
                        [ngModel]="selections[i]"
                        (ngModelChange)="select(i, $event)"
                        [appendTo]="appendToBody ? 'body' : null"
                        styleClass="simple-control"
                        placeholder="Select..."
                        [style]="{'width': '100%' }"
                        [showTransitionOptions]="'0ms'"
                        [hideTransitionOptions]="'0ms'"></p-dropdown>
          </div>
          <div *ngIf="selections[i] != null && !selectionLoading[i]">
            <simple-control *ngIf="!(selections[i].key == 'pickupstatecode' || selections[i].key == 'deliverystatecode')" [form]="form" (keyup.enter)="clickSearch()" [searchNumberOfVehicles]="(selections[i].type == 'number')" [key]="selections[i].key" [label]="selections[i].label" [type]="selections[i].type" [items]="(selections[i].type == 'lookup' ? lookups[selections[i].lookupKey] : null)"></simple-control>
            <p-multiSelect *ngIf="selections[i].key == 'pickupstatecode' || selections[i].key == 'deliverystatecode'" styleClass="simple-control w-100" appendTo="body" [options]="lookups[selections[i].lookupKey]" [formControl]="form.get(selections[i].key)" [maxSelectedLabels]="500"> </p-multiSelect>
          </div>
        </div>
        <div>
          <a (click)="clear()" class="link-button" style="text-align: right">Clear Filters</a>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="entityName != null">
    <button class="search-filter-button" [disabled]="form.status =='INVALID'" (click)="clickSearch()">
      <a [class]="form.status =='INVALID' || isLoading ? 'search-disabled' : ''">Search</a>
    </button>
  </div>
</div>
